import { getAuthProfile } from 'services/authAPI'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { IAuthState } from 'types/auth'
import { store } from 'store'




const initialState: IAuthState = {
    isLoggedIn: false,
    accessToken: null,
    error: '',
    refNo: '',
    token: '',
    mobile: '',
    profile: null,
    contact: null,
 }

 export const getProfile = createAsyncThunk(
  'getProfile',
  async (  ) => {
      try {
          const res = await getAuthProfile()
          store.dispatch(setProfileAndContact({ profile: res.profile, contact: res.contact }))
          return res
      } catch (error) {
          throw error
      }
  }
)


export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, action) => {
      const token = action.payload.access_token
      const isLoggedInKey = true
      if (token && isLoggedInKey) {
        localStorage.setItem("accessToken", JSON.stringify(token))
      }
      state.accessToken = token
      state.isLoggedIn = isLoggedInKey
      state.refNo = ''
      state.token = ''
      state.mobile = ''
    },
    sigOut: (state) => {
      localStorage.removeItem("accessToken")
      state.accessToken = null
      state.isLoggedIn = false
      state.refNo = ''
      state.token = ''
      state.mobile = ''
      state.profile = null
      state.contact = null
      
      // window.location.href = '/login'
      window.location.href = '/login'
    },
    setOtp: (state, action) => {
      const refNo = action.payload.ref_no
      const token = action.payload.token
      state.refNo = refNo
      state.token = token
    },
    setMobile: (state, action) => {
      const mobile = action.payload
      state.mobile = mobile
    },
    setProfileAndContact: (state, action) => {
      const profile = action.payload.profile
      const contact = action.payload.contact
      state.profile = profile
      state.contact = contact
    },
  },
})

export const { setAuth, sigOut, setOtp, setMobile, setProfileAndContact,  } = authSlice.actions
export default authSlice.reducer
